export default __webpack_public_path__ + "static/media/festering_desire.84492566.png";